import { Badge } from './badge';
import { Link } from 'wouter';
import { type User } from '@/db/types';
import { CatchCounter } from './catch-counter';
import styles from './ranking.module.css';

export const Ranking = ({
  as: Tag = 'div',
  variant = 'default',

  user,
  idx,
  score = user.score,
  catches = user.catches,
}: {
  as?: 'li' | 'div',
  variant?: 'default' | 'small',
  user: User,
  idx: number,
  score?: number,
  catches?: User['catches'],
}) => (
  <Tag
    className={ styles.ranking }
    data-variant={ variant }
    data-rank={ idx + 1 }
  >
    <Badge name={ user.name } />
    <p className={ styles.user }>
      { user.name }
      { variant !== 'small' && (
        <CatchCounter
          catches={ catches }
          className={ styles.catches }
        />
      ) }
    </p>
    <p className={ styles.score }>
      { score }
    </p>
    <Link to={ `/${user.name}` }>
      <span className="visually-hidden">
        View profile
      </span>
    </Link>
  </Tag>
);